export const NEUTRAL_EQ = { lowDb: 0, midDb: 0, highDb: 0 };
export const DEFAULT_STEM_VOLUME = 1;
//# sourceMappingURL=state.js.map